import React, { useState } from "react";
import { Button, Dropdown } from "antd";
import { useTranslation } from "react-i18next";
import PartnerReplacementModal from "./ClientInformSelect/PartnerReplacementModal";
import TemporarySubstitutionModal from "./ClientInformSelect/TemporarySubstitutionModal";
import CleaningDayChangeModal from "./ClientInformSelect/CleaningDayChangeModal";
import CleaningDayReschedulingModal from "./ClientInformSelect/CleaningDayReschedulingModal";

/**
 * ClientInformSelect - Dropdown menu for client notification options
 * Opens dedicated modal for each notification type
 */
const ClientInformSelect = ({ selectedUnits, editable = false }) => {
  const { t } = useTranslation();
  const [activeModal, setActiveModal] = useState(null);

  const dropdownMenu = {
    items: [
      {
        key: "replacement",
        label: t('clientInform.temporarySubstitution'),
        onClick: () => setActiveModal("replacement"),
      },
      {
        key: "switch",
        label: t('clientInform.partnerReplacement'),
        onClick: () => setActiveModal("switch"),
      },
      {
        key: "change",
        label: t('clientInform.cleaningDayChange'),
        onClick: () => setActiveModal("change"),
      },
      {
        key: "rescheduling",
        label: t('clientInform.cleaningDayRescheduling'),
        onClick: () => setActiveModal("rescheduling"),
      },
    ],
  };

  const handleCloseModal = () => {
    setActiveModal(null);
  };

  return (
    <div style={{ position: "relative", display: "inline-block" }}>
      <Dropdown menu={dropdownMenu} trigger={["click"]}>
        <Button size="small">{t('clientInform.informClient')}</Button>
      </Dropdown>

      <TemporarySubstitutionModal
        visible={activeModal === "replacement"}
        onClose={handleCloseModal}
        selectedUnits={selectedUnits}
        editable={editable}
      />

      <PartnerReplacementModal
        visible={activeModal === "switch"}
        onClose={handleCloseModal}
        selectedUnits={selectedUnits}
        editable={editable}
      />

      <CleaningDayChangeModal
        visible={activeModal === "change"}
        onClose={handleCloseModal}
        selectedUnits={selectedUnits}
        editable={editable}
      />

      <CleaningDayReschedulingModal
        visible={activeModal === "rescheduling"}
        onClose={handleCloseModal}
        selectedUnits={selectedUnits}
      />
    </div>
  );
};

export default ClientInformSelect;
